import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from "./home/home.component";
import { GrabacionComponent } from './grabacion/grabacion.component';
import {RecordCardListComponent } from './record-card-list/record-card-list.component';
const routes: Routes = [
    {
        path: "",
        component: HomeComponent
    },
    {
        path: "**",
        redirectTo: '/'
    },
    { path: 'logout', component: GrabacionComponent },
    { path: '', component: RecordCardListComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
